import React, {Component, useState, useEffect} from 'react'
import {Button, Container, Row, Col, FormLabel, FormControl, Modal} from 'react-bootstrap';
import JobDataService from "./services/job.service";
import FastQuotingCabinetDataService from './services/fastquotingcabinet.service';
import FastQuotingCabinetVersionsDataService from './services/fastquotingcabinetversions.service'
//import FinishCabinetDataService from './services/finishcabinets.service'
import ItemDataService from './services/item.service'
import FinishCabinetDoorDataService from './services/finishcabinetdoors.service'
import MessageBox from './MessageBox';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import QuoteVersionDetails from './QuoteVersionDetails';

import { usdCurrencyFormat } from "./numberFormats";
import SearchJob from './SearchJob';
import { dtFormatter, dtForInputDate, PageHeader, getUserRoles, NewHeader } from './AuxiliaryFunctions';
import TopAndSideBar from './TopAndSideBar';
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear();
var dtDate = newDate.getFullYear() + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getDate().toString().padStart(2,'0');

function transformArray(arr1) {
  /*
    id: idSelVal,
    partnumber: otherVal3,
    description: descSelVal,
    uom: otherVal,
    uomId: otherVal4,
    cost: otherVal2,
    itmqty: null  
  */

  return arr1.map(obj => {
    return { 
      id:obj.item.id,
      partnumber: obj.item.itempartnumber,
      description: obj.item.itemdescription, 
      uom: obj.item.primaryuom.unitofmeasureabbrev,
      uomId: obj.movementitemuomId,
      cost: obj.item.standardpurchaseunitprice,
      itmqty:obj.quantity 
    }; 
  }); 
}

const NewCabinetFastQuote = (props) => {
  const navigate = useNavigate();
  var newDate = new Date()
  var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear();  
  let params = useParams();

  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');

  const [raisedbyuser, setraisedbyuser] = useState('');
  const [job, setJob] = useState({});
  const [duedate, setDuedate] = useState('');
  const [raiseddate, setRaiseddate] = useState('');
  const [specialnotes, setSpecialnotes] = useState('');
  const [jobs, setJobs] = useState('');
  const [versionid, setVersionId] = useState(null);

  const [finishcabinets, setFinishCabinets] = useState([]);
  const [finishcabinetdoors, setFinishCabinetdoors] = useState([]);

  const [finishcabinet, setFinishCabinet] = useState({});  
  const [finishcabinetdoor, setFinishCabinetDoor] = useState({});  
  const [baseCabinets, setBaseCabinets] = useState(2);  
  const [wallCabinets, setWallCabinets] = useState(2);  
  const [tallCabinets, setTallCabinets] = useState(2);  
  const [finishEndsBaseCabinets, setFinishEndsBaseCabinets] = useState(2);  
  const [finishEndsWallCabinets, setFinishEndsWallCabinets] = useState(2);  
  const [finishEndsTallCabinets, setFinishEndsTallCabinets] = useState(2);  
  const [islandPanels, setIslandPanels] = useState(2);  
  const [drawers, setDrawers] = useState(2);  
  const [toeKicksEtc, setToeKicksEtc] = useState(1);  
  const [faceFrame, setFaceFrame] = useState(1);  
  const [installation, setInstallation] = useState(1);    
  const [delivery, setDelivery] = useState(0);  
  const [distance, setDistance] = useState(0);          

  /* BEGIN PARAMETERS*/
  const [assemblycostbasewallcost, setassemblycostbasewallcost] = useState(null);
  const [assemblycosttallcost, setassemblycosttallcost] = useState(null);
  const [hardwarehingesbasewallcost, sethardwarehingesbasewallcost] = useState(null);
  const [hardwarehingestallcost, sethardwarehingestallcost] = useState(null);

  const [routingcost, setroutingcost] = useState(null);
  const [routingcostcasesqftbase, setroutingcostcasesqftbase] = useState(null);
  const [routingcostcasesqftwall, setroutingcostcasesqftwall] = useState(null);
  const [routingcostcasesqfttall, setroutingcostcasesqfttall] = useState(null);
  const [routingcostbacksqftbase, setroutingcostbacksqftbase] = useState(null);
  const [routingcostbacksqftwall, setroutingcostbacksqftwall] = useState(null);
  const [routingcostbacksqfttall, setroutingcostbacksqfttall] = useState(null);
  const [routingcostdoorssqftbase, setroutingcostdoorssqftbase] = useState(null);
  const [routingcostdoorssqftwall, setroutingcostdoorssqftwall] = useState(null);
  const [routingcostdoorssqfttall, setroutingcostdoorssqfttall] = useState(null);
  const [routingcostfinishendssqftbase, setroutingcostfinishendssqftbase] = useState(null);
  const [routingcostfinishendssqftwall, sethroutingcostfinishendssqftwall] = useState(null);  
  const [routingcostfinishendssqfttall, setroutingcostfinishendssqfttall] = useState(null);  

  const [materialcostcasemarkup, setMaterialcostcasemarkup] = useState(null);
  const [materialcostbackmarkup, setMaterialcostbackmarkup] = useState(null);
  const [materialcostdoorsmarkup, setMaterialcostdoorsmarkup] = useState(null);
  const [materialcostfinishendsmarkup, setMaterialcostfinishendsmarkup] = useState(null);

  const [ebcostcasebase, setebcostcasebase] = useState(null);
  const [ebcostcasewall, setebcostcasewall] = useState(null);
  const [ebcostcasetall, setebcostcasetall] = useState(null);
  const [ebcostcasemarkup, setebcostcasemarkup] = useState(null);

  const [ebcostdoorsbase, setebcostdoorsbase] = useState(null);
  const [ebcostdoorswall, setebcostdoorswall] = useState(null);
  const [ebcostdoorstall, setebcostdoorstall] = useState(null);
  const [ebcostdoorsmarkup, setebcostdoorsmarkup] = useState(null);

  const [drawercostdrawer, setdrawercostdrawer] = useState(null);
  const [drawercosthardware, setdrawercosthardware] = useState(null);
  const [drawercostmarkup, setDrawercostmarkup] = useState(null);

  const [faceframemarkup, setFaceframemarkup] = useState(null);
  const [basicdeliverycost40cab, setbasicdeliverycost40cab] = useState(null);
  const [unknownfactor, setunknownfactor] = useState(null);
  const [calcs, setCalcs] = useState({});


  /**END PARAMETERS */

  const { user: currentUser } = useSelector((state) => state.auth);
  //const [users, setUsers] = useState('');
  //const user = props.user; // not needed
  const [item,setItem] = useState([]);
  const [totalmovement, setTotalmovement] = useState(0);

  const [editbr, setEditbr] = useState({});  
  const [fastQuoteCabinet, setFastQuoteCabinet] = useState({});
  const [mode, setMode] = useState(props.mode);
  const [userRoles, setUserRoles] = useState([]);  
  
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    console.log(editbr);
    setShow(true);
  };  

  const handleValidations = () => {
    onchangeMode();
  }  

  const onChangeJob = (e) => {
    let jobId = parseInt(e.target.value);
    console.log(jobId);
    console.log(jobs);
    setJob(jobs.find(obj => obj.id === jobId) || {});   
  }

  const onChangeSpecialNotes = (e) => {
    setSpecialnotes(e.target.value);
  }

  const onChangeFinishCabinet = (e) => {
    let finishcabinetId = parseInt(e.target.value);
    console.log(finishcabinetId);
    console.log(finishcabinets);
    console.log(finishcabinets.find(obj => obj.id === finishcabinetId) || {});
    setFinishCabinet(finishcabinets.find(obj => obj.id === finishcabinetId) || {});   
  }
    
  const onChangeFinishCabinetDoor = (e) => {
    let finishcabinetdoorId = parseInt(e.target.value);
    console.log(finishcabinetdoorId);
    console.log(finishcabinetdoors);
    console.log(finishcabinetdoors.find(obj => obj.id === finishcabinetdoorId) || {});
    setFinishCabinetDoor(finishcabinetdoors.find(obj => obj.id === finishcabinetdoorId) || {});   
  }  
    
  const onChangeBaseCabinets = (e) => {
    setBaseCabinets(e.target.value);
  }

  const onChangeWallCabinets = (e) => {
    setWallCabinets(e.target.value);
  }
  
  const onChangeTallCabinets = (e) => {
    setTallCabinets(e.target.value);
  }
  
  const onChangeFinishEndsBaseCabinets = (e) => {
    setFinishEndsBaseCabinets(e.target.value);
  }
   
  const onChangeFinishEndsWallCabinets = (e) => {
    setFinishEndsWallCabinets(e.target.value);
  }
  
  const onChangeFinishEndsTallCabinets = (e) => {
    setFinishEndsTallCabinets(e.target.value);
  }  

  const onChangeIslandPanels = (e) => {
    setIslandPanels(e.target.value);
  }  
  
  const onChangeDrawers = (e) => {
    setDrawers(e.target.value);
  }    

  const onChangeToeKicksEtc = (e) => {
    setToeKicksEtc(e.target.value);
  }    
  
  const onChangeFaceFrame = (e) => {
    setFaceFrame(e.target.value);
  }    
  
  const onChangeInstallation = (e) => {
    setInstallation(e.target.value);
  }    
  
  const onChangeDelivery = (e) => {
    setDelivery(e.target.value);
  }    
  
  const onChangeDistance = (e) => {
    setDistance(e.target.value);
  }    

  /** BEGIN PARAMETERS */
  const onChangeassemblycostbasewallcost = (e) => {
    setassemblycostbasewallcost(e.target.value);
  }  

  const onChangeassemblycosttallcost = (e) => {
    setassemblycosttallcost(e.target.value);
  }  

  const onChangehardwarehingesbasewallcost = (e) => {
    sethardwarehingesbasewallcost(e.target.value);
  }  

  const onChangehardwarehingestallcost = (e) => {
    sethardwarehingestallcost(e.target.value);
  }   


  const onChangeroutingcost = (e) => {
    setroutingcost(e.target.value);
  } 

  const onChangeroutingcostcasesqftbase = (e) => {
    setroutingcostcasesqftbase(e.target.value);
  }  

  const onChangeroutingcostcasesqftwall = (e) => {
    setroutingcostcasesqftwall(e.target.value);
  }  

  const onChangeroutingcostcasesqfttall = (e) => {
    setroutingcostcasesqfttall(e.target.value);
  }  

  const onChangeroutingcostbacksqftbase = (e) => {
    setroutingcostbacksqftbase(e.target.value);
  }  

  const onChangeroutingcostbacksqftwall = (e) => {
    setroutingcostbacksqftwall(e.target.value);
  }  

  const onChangeroutingcostbacksqfttall = (e) => {
    setroutingcostbacksqfttall(e.target.value);
  }  

  const onChangeroutingcostdoorssqftbase = (e) => {
    setroutingcostdoorssqftbase(e.target.value);
  }  

  const onChangeroutingcostdoorssqftwall = (e) => {
    setroutingcostdoorssqftwall(e.target.value);
  }  
  
  const onChangeroutingcostdoorssqfttall = (e) => {
    setroutingcostdoorssqfttall(e.target.value);
  }  

  const onChangeroutingcostfinishendssqftbase = (e) => {
    setroutingcostfinishendssqftbase(e.target.value);
  }  

  const onChangeroutingcostfinishendssqftwall = (e) => {
    sethroutingcostfinishendssqftwall(e.target.value);
  }  

  const onChangeroutingcostfinishendssqfttall = (e) => {
    setroutingcostfinishendssqfttall(e.target.value);
  }    

const onChangematerialcostcasemarkup = (e) => {
  setMaterialcostcasemarkup(e.target.value);
};

const onChangematerialcostbackmarkup = (e) => {
  setMaterialcostbackmarkup(e.target.value);
};

const onChangematerialcostdoorsmarkup = (e) => {
  setMaterialcostdoorsmarkup(e.target.value);
};

const onChangematerialcostfinishendsmarkup = (e) => {
  setMaterialcostfinishendsmarkup(e.target.value);
};

const onChangeebcostcasebase = (e) => {
  setebcostcasebase(e.target.value);
};

const onChangeebcostcasewall = (e) => {
  setebcostcasewall(e.target.value);
};

const onChangeebcostcasetall = (e) => {
  setebcostcasetall(e.target.value);
};

const onChangeebcostcasemarkup = (e) => {
  setebcostcasemarkup(e.target.value);
};

const onChangeebcostdoorsbase = (e) => {
  setebcostdoorsbase(e.target.value);
};

const onChangeebcostdoorswall = (e) => {
  setebcostdoorswall(e.target.value);
};

const onChangeebcostdoorstall = (e) => {
  setebcostdoorstall(e.target.value);
};

const onChangeebcostdoorsmarkup = (e) => {
  setebcostdoorsmarkup(e.target.value);
};

const onChangedrawercostdrawer = (e) => {
  setdrawercostdrawer(e.target.value);
};

const onChangedrawercosthardware = (e) => {
  setdrawercosthardware(e.target.value);
};

const onChangedrawercostmarkup = (e) => {
  setDrawercostmarkup(e.target.value);
};

const onChangefaceframemarkup = (e) => {
  setFaceframemarkup(e.target.value);
};  

const onChangebasicdeliverycost40cab = (e) => {
  setbasicdeliverycost40cab(e.target.value);
}; 

const onChangeunknownfactor = (e) => {
  setunknownfactor(e.target.value);
}; 

  /* END PARAMETERS*/

  const onChangeDueDate = (e) => {    
    //let localDate = new Date(e.target.valueAsNumber);
    //const now_utc = new Date(localDate.toUTCString().slice(0, -4));
    //console.log(now_utc.toString()); // ignore the timezone
    //let utcdDate = Date.UTC(localDate.getUTCFullYear(), localDate.getUTCMonth(),
    //localDate.getUTCDate(), localDate.getUTCHours(),
    //localDate.getUTCMinutes(), localDate.getUTCSeconds());
    //setDuedate(e.target.value);  
    //console.log(utcdDate);
    //setDuedate(now_utc.toString());      
    setDuedate(new Date(dtFormatter(e.target.valueAsNumber,3)).valueOf());
  }  

  const onJobSelected = (idSelVal, descSelVal, otherVal, otherVal2,otherVal3) => {    
    setJob({
      id: parseInt(idSelVal),
      jobtitle: descSelVal,
      jobdescription: otherVal,
      clientId: otherVal2,
      clientname: otherVal3
    });
  }   



  const onCancelCabinetFastQuoting = () => {
    //console.log("code to cancel here");
    handleClose();
    /*
    MovementDataService.update(editbr.id,{bookinrequeststatus:5})
    .then((response) => {
      console.log(response);
      window.location.reload();
    })      
    .catch((err) => {
      console.log(err);
    })
    */
  }    

  const retrieveJobs = () => {
    JobDataService.getAll()
      .then(response => {
        setJobs(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }   
  
  const retrieveFinishCabinets = () => {
    ItemDataService.getItemByCategory({"itemcategory":"finish_cabinet_box_case", "itemcategoryval":1},"id","ASC")
    .then(response => {
      setFinishCabinets(response.data);
      console.log(response.data);
    })
    .catch(e => {
      console.log(e);
    });    
    /*
    FinishCabinetDataService.getAll()
      .then(response => {
        setFinishCabinets(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
    */
  } 
  
  const retrieveFinishCabinetDoors = () => {
    ItemDataService.getItemByCategory({"itemcategory":"finish_cabinet_door", "itemcategoryval":1},"id","ASC")
    .then(response => {
      setFinishCabinetdoors(response.data);
      console.log(response.data);
    })
    .catch(e => {
      console.log(e);
    }); 
    /*
    FinishCabinetDoorDataService.getAll()
      .then(response => {
        setFinishCabinetdoors(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
    */
  }   

  useEffect (() => {
    //setraisedby(user.id);
    //setraisedbyemail(user.email);
    retrieveJobs();
    retrieveFinishCabinets();
    retrieveFinishCabinetDoors();
    if (mode === 0) {
      setraisedbyuser(currentUser);
    }
    else {
      setDuedate(new Date(duedate).valueOf());
    }
    getUserRoles(currentUser.id).then(resp => {
      console.log(resp);
      setUserRoles(resp);
    });
  },[currentUser])

  useEffect (() => {
    console.log(item);
  },[item]);

  useEffect(() => {
    setFinishCabinet(finishcabinets.find(obj => parseInt(obj.id) == parseInt(editbr.finishcabinet)) || {});        
    setFinishCabinetDoor(finishcabinetdoors.find(obj => parseInt(obj.id) == parseInt(editbr.finishcabinetdoor)) || {});   
    //setBaseCabinets(editbr.baseCabinets); it doesn't work
    setassemblycostbasewallcost(editbr.assemblycostbasewallcost);
    setassemblycosttallcost(editbr.assemblycosttallcost);

    sethardwarehingesbasewallcost(editbr.hardwarehingesbasewallcost);
    sethardwarehingestallcost(editbr.hardwarehingestallcost);

    setroutingcost(editbr.routingcost);
    setroutingcostcasesqftbase(editbr.routingcostcasesqftbase);
    setroutingcostcasesqftwall(editbr.routingcostcasesqftwall);
    setroutingcostcasesqfttall(editbr.routingcostcasesqfttall);    
    setroutingcostbacksqftbase(editbr.routingcostbacksqftbase);
    setroutingcostbacksqftwall(editbr.routingcostbacksqftwall);
    setroutingcostbacksqfttall(editbr.routingcostbacksqfttall);
    setroutingcostdoorssqftbase(editbr.routingcostdoorssqftbase);    
    setroutingcostdoorssqftwall(editbr.routingcostdoorssqftwall);
    setroutingcostdoorssqfttall(editbr.routingcostdoorssqfttall);
    setroutingcostfinishendssqftbase(editbr.routingcostfinishendssqftbase);
    sethroutingcostfinishendssqftwall(editbr.routingcostfinishendssqftwall);    
    setroutingcostfinishendssqfttall(editbr.routingcostfinishendssqfttall);

    setMaterialcostcasemarkup(editbr.materialcostcasemarkup);
    setMaterialcostbackmarkup(editbr.materialcostbackmarkup);
    setMaterialcostdoorsmarkup(editbr.materialcostdoorsmarkup);
    setMaterialcostfinishendsmarkup(editbr.materialcostfinishendsmarkup);
    
    setebcostcasebase(editbr.ebcostcasebase);
    setebcostcasewall(editbr.ebcostcasewall);
    setebcostcasetall(editbr.ebcostcasetall);
    setebcostcasemarkup(editbr.ebcostcasemarkup);

    setebcostdoorsbase(editbr.ebcostdoorsbase);
    setebcostdoorswall(editbr.ebcostdoorswall);
    setebcostdoorstall(editbr.ebcostdoorstall);
    setebcostdoorsmarkup(editbr.ebcostdoorsmarkup);

    setdrawercostdrawer(editbr.drawercostdrawer);    
    setdrawercosthardware(editbr.drawercosthardware);
    setDrawercostmarkup(editbr.drawercostmarkup);

    setFaceframemarkup(editbr.faceframemarkup);    

    setbasicdeliverycost40cab(editbr.basicdeliverycost40cab);    
    setunknownfactor(editbr.unknownfactor);
  },[editbr]);

  useEffect (() => {    
    console.log(mode); 
    console.log(editbr);
    console.log(Object.keys(editbr).length > 0);

    if (mode === 0) { // create
      setraisedbyuser(currentUser);
      setRaiseddate(dtFormatter(new Date(),1));
      setEditbr({empty:true});   
    }  
    else { // view or edit
      
      FastQuotingCabinetVersionsDataService.findById(params.id)      
      .then((response) => {
        var respdata = response.data;
        console.log(respdata);
        setraisedbyuser(respdata.user);
        setRaiseddate(dtFormatter(new Date(respdata.createdAt),2));
        setEditbr(respdata);    
        setJob(respdata.fastquotingcabinet.job);   
        setDuedate(new Date(respdata.duedate).valueOf());
        console.log(dtForInputDate(duedate));
        setFastQuoteCabinet(respdata.fastquotingcabinet);
        //setBaseCabinets(respdata.baseCabinets); it doesn't work
        setCalcs(respdata.calculation[0]);
      })
      .catch((error) => {
        console.log(error);
      });           
    }      
  },[])   

  const handleSave = () => {
    if (job && Object.keys(job).length === 0) { //
      setShowerror(true);
      setErrmessage('Job not selected!')
      return;
    }   
    
    if (!finishcabinet.id) {
      setShowerror(true);
      setErrmessage('Please, select a finish for the cabinet box case!');
      return;      
    }

    if (!finishcabinetdoor.id) {
      setShowerror(true);
      setErrmessage('Please, select a finish for the cabinet door!');
      return;      
    }
         
    console.log(props);
    console.log(raisedbyuser);
  
    if (mode === 0) { // create first version
      // fast quoting cabinet
      var data = {
        userId: raisedbyuser.id,
        jobId: parseInt(job.id),
        duedate: duedate,
        fastquotingcabinetstatus:1,      
      };
      console.log(data);      

      FastQuotingCabinetDataService.create(data)      
      .then(response => {   
        console.log(data);
        var dataupdate = {
          fastquotingcabinetnumber: 'FQCab-' + response.data.id.toString().padStart(5,'0')
        };
        FastQuotingCabinetDataService.update(response.data.id, dataupdate)          
        .then(() => {
          handleSaveVersion(response.data.id, mode);        
        })
        .catch((err) => {
          console.log(err);
        })
        
      })      
      .catch(e => {
        console.log(e);        
        setShowsuccess(false);
        setSuccmessage('');
        setShowerror(true);
        setErrmessage(e.response?e.response.data.message:e.message)        
        //console.log(e.response.status === 401);
        if (e.response.status === 401) {
          window.location.reload();
        }
      }); 
    }
    else if (mode === 1) { // edit this quote version
      
      var data = {
        jobId: job?parseInt(job.id):null
      };
      
      FastQuotingCabinetDataService.update(editbr.fastquotingcabinetId, data)      
      .then(() => {   
        handleSaveVersion(editbr.fastquotingcabinetId, mode);        
      })      
      .catch(e => {
        console.log(e);        
        setShowsuccess(false);
        setSuccmessage('');
        setShowerror(true);
        setErrmessage(e.response?e.response.data.message:e.message)        
        //console.log(e.response.status === 401);
        if (e.response.status === 401) {
          window.location.reload();
        }
      });
    }    
  }

  const handleSaveVersion = async (fastquotingcabinetId, mode) => {

    var data = {
      fastquotingcabinetId: fastquotingcabinetId,
      userId: raisedbyuser.id,
      comments: specialnotes,
      finishcabinet: finishcabinet.id,
      finishcabinetdoor: finishcabinetdoor.id,
      baseCabinets:baseCabinets,
      wallCabinets:wallCabinets,  
      tallCabinets:tallCabinets,  
      finishEndsBaseCabinets:finishEndsBaseCabinets,
      finishEndsWallCabinets:finishEndsWallCabinets,
      finishEndsTallCabinets:finishEndsTallCabinets,
      islandsPanels:islandPanels,
      drawers:drawers,
      toeKicksEtc:toeKicksEtc,
      faceFrame:faceFrame,
      installation:installation,
      delivery:delivery,
      distance:distance,
      //versionnumber: 1,
    }

    console.log(data);
    if (mode === 0) { // create
      data.versionnumber = 1;
      
      FastQuotingCabinetVersionsDataService.create(data)
      .then(response => {          
        console.log(response);
        setVersionId(response.data.calcs.versionid);
        setShowsuccess(true);
        setSuccmessage('Fast Quoting Cabinet has been created successfully.');
        setShowerror(false);
        setErrmessage('');                
      })  
      .catch(e => {
        setShowsuccess(false);
        setSuccmessage('');
        setShowerror(true);
        setErrmessage(e.response?e.response.data.message:e.message);                  
      })       
    }
    else if (mode === 1) {
      // copy parameters of this quote
      var data_params = {
        assemblycostbasewallcost: assemblycostbasewallcost,
        assemblycosttallcost: assemblycosttallcost,
        hardwarehingesbasewallcost: hardwarehingesbasewallcost,
        hardwarehingestallcost: hardwarehingestallcost,
        routingcost:routingcost,
        routingcostcasesqftbase:routingcostcasesqftbase,
        routingcostcasesqftwall:routingcostcasesqftwall,
        routingcostcasesqfttall: routingcostcasesqfttall,
        routingcostbacksqftbase:routingcostbacksqftbase,
        routingcostbacksqftwall:routingcostbacksqftwall,
        routingcostbacksqfttall:routingcostbacksqfttall,
        routingcostdoorssqftbase:routingcostdoorssqftbase,
        routingcostdoorssqftwall:routingcostdoorssqftwall,
        routingcostdoorssqfttall:routingcostdoorssqfttall,
        routingcostfinishendssqftbase:routingcostfinishendssqftbase,
        routingcostfinishendssqftwall:routingcostfinishendssqftwall,
        routingcostfinishendssqfttall:routingcostfinishendssqfttall,
        materialcostcasemarkup: materialcostcasemarkup,
        materialcostbackmarkup: materialcostbackmarkup,
        materialcostdoorsmarkup: materialcostdoorsmarkup,
        materialcostfinishendsmarkup: materialcostfinishendsmarkup,

        ebcostcasebase: ebcostcasebase,
        ebcostcasewall: ebcostcasewall,
        ebcostcasetall: ebcostcasetall,
        ebcostcasemarkup: ebcostcasemarkup,

        ebcostdoorsbase: ebcostdoorsbase,
        ebcostdoorswall: ebcostdoorswall,
        ebcostdoorstall: ebcostdoorstall,
        ebcostdoorsmarkup: ebcostdoorsmarkup,        
        
        drawercostdrawer: drawercostdrawer,
        drawercosthardware: drawercosthardware,
        drawercostmarkup: drawercostmarkup,

        faceframemarkup: faceframemarkup,
        basicdeliverycost40cab: basicdeliverycost40cab,
        unknownfactor: unknownfactor,

      }
      Object.assign(data, data_params);
      console.log(data);
      setVersionId(editbr.id);

      FastQuotingCabinetVersionsDataService.update(editbr.id, data)
      .then(response => {          
        console.log(response.data.calcs);
        setCalcs(response.data.calcs);
        setShowsuccess(true);
        setSuccmessage('Fast Quoting Cabinet has been updated successfully.');
        setShowerror(false);
        setErrmessage('');                
      })  
      .catch(e => {
        setShowsuccess(false);
        setSuccmessage('');
        setShowerror(true);
        setErrmessage(e.response?e.response.data.message:e.message);                  
      });      
    }
    

  }

  const onchangeMode = () => {
    console.log("running change mode");
    console.log(mode);
    if (mode === 1) {
      setMode(2);
      // confirm cancel edition
      // not needed now I would say...

      // change everything back
      onCancelEditionConfirmed();
    }
    else if (mode === 2 ) {
      setMode(1);
      console.log(editbr);
      
      setBaseCabinets(editbr.baseCabinets);
      setWallCabinets(editbr.wallCabinets);
      setTallCabinets(editbr.tallCabinets);
      setFinishEndsBaseCabinets(editbr.finishEndsBaseCabinets);
      setFinishEndsWallCabinets(editbr.finishEndsWallCabinets);
      setFinishEndsTallCabinets(editbr.finishEndsTallCabinets);
      setIslandPanels(editbr.islandsPanels);
      setDrawers(editbr.drawers);
      setToeKicksEtc(editbr.toeKicksEtc);
      setFaceFrame(editbr.faceFrame);
      setInstallation(editbr.installation);
      setDelivery(editbr.delivery);
      setDistance(editbr.distance);
      setJob(editbr.fastquotingcabinet.job);

    }    
  }

  const onCancelEditionConfirmed = () => {
    setraisedbyuser(editbr.user);
    setRaiseddate(dtFormatter(new Date(editbr.createdAt),2));
    setJob(editbr.fastquotingcabinet.job);        //id
    setDuedate(new Date(editbr.duedate).valueOf());
    console.log(dtForInputDate(duedate));
  }  

  const title = mode === 0? "New Cabinet Fast Quote":
    "Cabinet Fast Quote " + fastQuoteCabinet.fastquotingcabinetnumber + "," + " version: " + ((editbr.versionnumber)?editbr.versionnumber:"").padStart(5,"0");
  return (
    <>
    <div style={{display:"flex", flexDirection:"column",width:"100%"}}>
      <TopAndSideBar />
      <NewHeader headerTitle={title}/>
      <Container>
        <Row style={{position:'sticky',top:'50px',backgroundColor:'white',zIndex:'10'}}> 
          <h4 className='mb-2' style={{width: "100%", textAlign: "left", marginLeft: "0%", color: "green" }}>

          </h4>                
          <Col>     
            {<><Button style={{width:"100%"}} onClick={handleSave} disabled={mode===2}>Save This Version</Button></>}         
          </Col>
          {(mode !== 0) && ([3,6].some(i => userRoles.includes(i))) && 
            <>
            <Col>     
            {<><Button style={{width:"100%"}} onClick={handleValidations} disabled={mode===1}>Edit This Version</Button></>}               
            </Col>
            <Col>     
            {<><Button variant="danger" style={{width:"100%"}} onClick={handleShow} disabled={mode!==1}>View/Edit Parameters</Button></>}               
            </Col>            
            </>
          }
          <Col style={{textAlign:'right'}}>
            <FormLabel htmlFor="job">Total Quote:</FormLabel>  
          </Col>          
          
          <Col>     
            <Row className='row-md-3' sm={8}>
              
              <div style={{display:"flex"}}>
                <FormControl className="form-control mb-3"
                  disabled={true}
                  type="text"
                  name="totalquoteversion"
                  id="totalquoteversion"
                  value={usdCurrencyFormat(calcs.totalquoteversionwithunknownfactor?calcs.totalquoteversionwithunknownfactor:0)} 
                />
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                >        
                  <QuoteVersionDetails 
                    calcs={calcs} 
                    assemblycostbasewallcost={assemblycostbasewallcost}
                    assemblycosttallcost={assemblycosttallcost}
                    hardwarehingesbasewallcost={hardwarehingesbasewallcost}
                    hardwarehingestallcost={hardwarehingestallcost}

                    routingcost={routingcost}
                    routingcostcasesqftbase={routingcostcasesqftbase}
                    routingcostcasesqftwall={routingcostcasesqftwall}
                    routingcostcasesqfttall={routingcostcasesqfttall}
                    routingcostbacksqftbase={routingcostbacksqftbase}
                    routingcostbacksqftwall={routingcostbacksqftwall}
                    routingcostbacksqfttall={routingcostbacksqfttall}
                    routingcostdoorssqftbase={routingcostdoorssqftbase}
                    routingcostdoorssqftwall={routingcostdoorssqftwall}
                    routingcostdoorssqfttall={routingcostdoorssqfttall}
                    routingcostfinishendssqftbase={routingcostfinishendssqftbase}
                    routingcostfinishendssqftwall={routingcostfinishendssqftwall}
                    routingcostfinishendssqfttall={routingcostfinishendssqfttall}

                    materialcostcasemarkup={materialcostcasemarkup}
                    materialcostbackmarkup={materialcostbackmarkup}
                    materialcostdoorsmarkup={materialcostdoorsmarkup}
                    materialcostfinishendsmarkup={materialcostfinishendsmarkup}

                    ebcostcasebase={ebcostcasebase}
                    ebcostcasewall={ebcostcasewall}
                    ebcostcasetall={ebcostcasetall}
                    ebcostcasemarkup={ebcostcasemarkup}

                    ebcostdoorsbase={ebcostdoorsbase}
                    ebcostdoorswall={ebcostdoorswall}
                    ebcostdoorstall={ebcostdoorstall}
                    ebcostdoorsmarkup={ebcostdoorsmarkup}

                    drawercostdrawer={drawercostdrawer}
                    drawercosthardware={drawercosthardware}
                    drawercostmarkup={drawercostmarkup}

                    faceframemarkup={faceframemarkup}
                    basicdeliverycost40cab={basicdeliverycost40cab}
                    unknownfactor={unknownfactor}  
                    
                    
                  />    
                </OverlayTrigger>                 
              </div>                
            </Row>                
          </Col>          
          <hr/>
        </Row> 

        <Container>

          <Row className='mt-2' >
            <Col className='col-md-3' sm={8}>
              <FormLabel htmlFor="todaydate">Raised Date:</FormLabel>
              <FormControl className="form-control"
                defaultValue={raiseddate}
                type="text"
                name="todaydate"
                disabled
                id="todaydate" />
            </Col>
            <Col className='col-md-3' sm={8}>
              <FormLabel className="mr-5" htmlFor="raisedby">Raised By:</FormLabel>
              <FormControl className="form-control"
                defaultValue= {raisedbyuser.username} ////////////////////////////////////////////////////////////////////////////////
                type="text"
                name="raisedby"
                disabled
                id="raisedby" />
            </Col>

            <Col className='col-md-3' sm={8}>
              <FormLabel className="mr-5" htmlFor="raisedbyemail">Raised By Email:</FormLabel>
              <FormControl className="form-control"
                defaultValue={raisedbyuser.email}
                type="text"
                name="raisedbyemail"
                disabled
                id="raisedbyemail" />
            </Col>

            <Col className='col-md-3' sm={8}>
              <FormLabel className="mr-5" htmlFor="tel">Raised By Telephone:</FormLabel>
              <FormControl className="form-control mb-3"
                disabled={mode === 2}
                type="text"
                name="tel"
                id="tel" 
              />
            </Col>

            <Col className='col-md-3' sm={8} >
              <FormLabel className="mr-5" htmlFor="job">Job:</FormLabel>
              <div style={{display:"flex"}}>
              <select value={job?job.id:editbr.fastquotingcabinet.job?editbr.fastquotingcabinet.job.id:null} onChange={onChangeJob} className="form-control" id="job" name="job" disabled={mode===2}>
                <ListOfJobs jobs={jobs}/>       
              </select>

              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
              >        
                <SearchJob onSelected={onJobSelected} disabled={mode===2}/>    
              </OverlayTrigger> 
              </div>
            </Col>

            <Col className='col-md-3' sm={8}>
              <FormLabel className="mr-5" htmlFor="duedate">Due Date:</FormLabel>
              <FormControl
                disabled={mode === 2}
                className="form-control" 
                onChange={onChangeDueDate} 
                id="duedate" 
                type="date" 
                data-date="" 
                data-date-format="DD-MM-YYYY" 
                value={mode===0?null:dtForInputDate(duedate)}
              />
            </Col>           

          </Row>

          <Row className='mt-4' >
            <Col className='col-md-4' sm={8}>
              <FormLabel className="mr-5" htmlFor="notes">Special Notes:</FormLabel>
              <FormControl className="form-control mb-3"
                disabled={mode===2}
                onChange={onChangeSpecialNotes}
                as="textarea"
                rows="5"
                type="text"
                name="notes"
                id="notes" 
                defaultValue={mode===0?null:editbr.specialnotes}
              />    
              
            </Col>  
          </Row>
          

  {/*///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////*/}

          <Row className='md-3 card-container'>
            <h4 className='mb-2' style={{width: "100%", marginLeft: "0%", color: "green" }}>Job Interview</h4>
            <Col className='card'>
              <FormLabel>1 SELECT FINISH FOR THE CABINET BOX CASE:</FormLabel>
              <div style={{display:"flex"}}>
              <select onChange={onChangeFinishCabinet} className="form-control" id="finishcabinet" name="finishcabinet" disabled={mode===2}>
                <ListOfFinishCabinet finishcabinets={finishcabinets} defaultValue={!editbr.empty?editbr.finishcabinet:null}/>       
              </select>
              </div>
              <FormLabel className='mt-2 form-control-sm'>Select your finish from the list above.</FormLabel>
            </Col>

            <Col className='card'>
              <FormLabel className='mt-2'>2 AUTO-SELECTION BACK FINISH:</FormLabel>
              <FormControl type="text" name="client" id="backfinish" disabled defaultValue={finishcabinet?finishcabinet.defaultbackfinish:null}></FormControl>
              <FormLabel className='mt-2 form-control-sm'>Match back finish to box finish.</FormLabel>
            </Col>
            <hr/> 
          </Row>  

          <Row>
            <Col className='card' >
              <FormLabel>3 SELECT FINISH FOR THE CABINET DOOR:</FormLabel>
              <div style={{display:"flex"}}>
              <select onChange={onChangeFinishCabinetDoor} className="form-control" id="finishcabinetdoor" name="finishcabinetdoor" disabled={mode===2}>
                <ListOfFinishCabinetDoor finishcabinetdoors={finishcabinetdoors} defaultValue={!editbr.empty?editbr.finishcabinetdoor:null}/>       
              </select>
              </div>
              <FormLabel className='mt-2 form-control-sm'>Match back finish to box finish.</FormLabel>
            </Col>   

            <Col className='card'>
              <FormLabel className='mt-2'>4 TOTAL BASE CABINETS W24" x H34.5" x D24" [1 shelf]:</FormLabel>
              <FormControl onChange={onChangeBaseCabinets} type="number" name="totalbasecabinets" id="totalbasecabinets" defaultValue={!editbr.empty?editbr.baseCabinets:2} disabled={mode===2}></FormControl>
              <FormLabel className='mt-2 form-control-sm'>Count the TOTAL number of base cabinets you have in your project and introduce into the cell bellow the final count.</FormLabel>
            </Col>                  
            <hr/>             
          </Row>

          <Row>
            <Col className='card'>
              <FormLabel className='mt-2'>5 TOTAL WALL CABINETS W24" x H36" x D13" [2 shelves]:</FormLabel>
              <FormControl onChange={onChangeWallCabinets} type="number" name="totalwallcabinets" id="totalwallcabinets" defaultValue={!editbr.empty?editbr.wallCabinets:2} disabled={mode===2}></FormControl>
              <FormLabel className='mt-2 form-control-sm'>Count the TOTAL number of wall cabinets you have in your project and introduce into the cell bellow the final count.</FormLabel>
            </Col>                  

            <Col className='card'>
              <FormLabel className='mt-2'>6 TOTAL TALL CABINETS W24" x H96" x D24" [3 shelves]:</FormLabel>
              <FormControl onChange={onChangeTallCabinets} type="number" name="totaltallcabinets" id="totaltallcabinets" defaultValue={!editbr.empty?editbr.tallCabinets:2} disabled={mode===2}></FormControl>
              <FormLabel className='mt-2 form-control-sm'>Count the TOTAL number of tall cabinets you have in your project and introduce into the cell bellow the final count.</FormLabel>
            </Col>
            <hr/>             
          </Row>

          <Row>
            <Col className='card'>
              <FormLabel className='mt-2'>7 TOTAL FINISH ENDS BASE CABINETS:</FormLabel>
              <FormControl onChange={onChangeFinishEndsBaseCabinets} type="number" name="totalfinishendsbasecabinets" id="totalfinishendsbasecabinets" defaultValue={!editbr.empty?editbr.finishEndsBaseCabinets:2} disabled={mode===2}></FormControl>
              <FormLabel className='mt-2 form-control-sm'>Count the TOTAL number of base cabinets panels like: finish ends, diswasher panels...etc.</FormLabel>
            </Col>                  

            <Col className='card'>
              <FormLabel className='mt-2'>8 TOTAL FINISH ENDS WALL CABINETS:</FormLabel>
              <FormControl onChange={onChangeFinishEndsWallCabinets} type="number" name="totalfinishendswallcabinets" id="totalfinishendswallcabinets" defaultValue={!editbr.empty?editbr.finishEndsWallCabinets:2} disabled={mode===2}></FormControl>
              <FormLabel className='mt-2 form-control-sm'>Count the TOTAL number of base cabinets panels like: left and right finish ends...etc.</FormLabel>
            </Col>
          
            <hr/> 
          </Row>

          
          <Row>
            <Col className='card'>
              <FormLabel className='mt-2'>9 TOTAL FINISH ENDS TALL CABINETS:</FormLabel>
              <FormControl onChange={onChangeFinishEndsTallCabinets} type="number" name="totalfinishendstallcabinets" id="totalfinishendstallcabinets" defaultValue={!editbr.empty?editbr.finishEndsTallCabinets:2} disabled={mode===2}></FormControl>
              <FormLabel className='mt-2 form-control-sm'>Count the TOTAL number of tall cabinets panels like: finish ends, fridge panels...etc.</FormLabel>
            </Col>                

            <Col className='card'>
              <FormLabel className='mt-2'>10 TOTAL ISLAND PANELS:</FormLabel>
              <FormControl onChange={onChangeIslandPanels} type="number" name="totalislandpanels" id="totalislandpanels" defaultValue={!editbr.empty?editbr.islandsPanels:2} disabled={mode===2}></FormControl>
              <FormLabel className='mt-2 form-control-sm'>Count the TOTAL number of panels from the island cabinets.</FormLabel>
            </Col>
            <hr/> 
          </Row>

          
          <Row>
            <Col className='card'>
              <FormLabel className='mt-2'>11 TOTAL DRAWERS:</FormLabel>
              <FormControl onChange={onChangeDrawers} type="number" name="totaldrawers" id="totaldrawers" defaultValue={!editbr.empty?editbr.drawers:2} disabled={mode===2}></FormControl>
              <FormLabel className='mt-2 form-control-sm'>Count the TOTAL number of drawers you have in your project and introduce into the cell bellow the final count.</FormLabel>
            </Col>  
            <Col className='card'>
              <FormLabel>12 TOE KICKS, FILLERS, LIGHT VALANCE, CROWN MOLDING (PANELS ONLY):</FormLabel>
              <div style={{display:"flex"}}>
              <select onChange={onChangeToeKicksEtc} className="form-control" id="toekicksetc" name="toekicksetc" disabled={mode===2}>
                <option value={1} selected={!editbr.empty?editbr.toeKicksEtc == 1:true}>Yes</option>      
                <option value={0} selected={!editbr.empty?editbr.toeKicksEtc == 0:false}>No</option>      
              </select>
              </div>
              <FormLabel className='mt-2 form-control-sm'>Select YES or NO if needed.</FormLabel>
            </Col>                              
          </Row>   

          <Row>
            <Col className='card'>
              <FormLabel>13 FACE FRAME:</FormLabel>
              <div style={{display:"flex"}}>
              <select onChange={onChangeFaceFrame} className="form-control" id="faceframe" name="faceframe" disabled={mode===2}>
                <option value={1} selected={!editbr.empty?editbr.faceFrame == 1:false}>Yes</option>      
                <option value={0} selected={!editbr.empty?editbr.faceFrame == 0:true}>No</option>      
              </select>
              </div>
              <FormLabel className='mt-2 form-control-sm'>Select YES or NO if needed.</FormLabel>
            </Col> 

            <Col className='card'>
              <FormLabel>14 INSTALLATION:</FormLabel>
              <div style={{display:"flex"}}>
              <select onChange={onChangeInstallation} className="form-control" id="installation" name="installation" disabled={mode===2}>
                <option value={1} selected={!editbr.empty?editbr.installation == 1:true}>Yes</option>      
                <option value={0} selected={!editbr.empty?editbr.installation == 0:false}>No</option>      
              </select>
              </div>
              <FormLabel className='mt-2 form-control-sm'>Select YES or NO if needed.</FormLabel>
            </Col> 
          </Row>

          <Row> 
            <Col className='card'>
              <FormLabel>15 DELIVERY:</FormLabel>
              <div style={{display:"flex"}}>
              <select onChange={onChangeDelivery} className="form-control" id="delivery" name="delivery" disabled={mode===2}>
                <option value={1} selected={!editbr.empty?editbr.delivery == 1:false}>Yes</option>      
                <option value={0} selected={!editbr.empty?editbr.delivery == 0:true}>No</option>      
              </select>
              </div>
              <FormLabel className='mt-2 form-control-sm'>Select YES or NO if needed.</FormLabel>
            </Col> 

            <Col className='card'>
              <FormLabel>Let us know roughly how many miles your jobsite is from Orange, CA (Max 450 miles):</FormLabel>
              <FormControl onChange={onChangeDistance} type="number" name="distance" id="distance" defaultValue={!editbr.empty?editbr.distance:0} disabled={mode===2 || delivery === 0}></FormControl>
            </Col>             
          </Row>



          <Row className='mt-2'>

            {showerror && (
              <MessageBox show={true} showerror={showerror} errmessage={errmessage}
                onHide={() => {
                  setShowerror(false)
                }}
              />
            )}
            {showsuccess && (

              <MessageBox show={true} showsuccess={showsuccess} succmessage={succmessage}
                onHide={() => {
                setShowsuccess(false);
                navigate('/view-cabinet-fast-quoting/' + versionid);
                window.location.reload();
                //window.location.assign('');
              }}
              />
            )}
            <hr/>    
          </Row>                
          
          
          {/**
           * 
          <Row style={{position:'static',top:'0'}}>     
            <Col xs={3}>     
              {<><Button style={{width:"100%"}} onClick={handleSave} disabled={mode===2}>Save This Quote Version</Button></>}         
            </Col>
            {(mode !== 0) && ([3,6].some(i => userRoles.includes(i))) && 
              <>
              <Col xs={3}>     
              {<><Button style={{width:"100%"}} onClick={handleValidations} disabled={mode===1}>Edit This Quote Version</Button></>}               
              </Col>
              <Col xs={3}>     
              {<><Button variant="danger" style={{width:"100%"}} onClick={handleShow} disabled={mode!==1}>View/Edit Parameters</Button></>}               
              </Col>            
              </>
            }
          </Row> 
           */}


          <Modal show={show} size="xl" fullscreen={false} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Quote Version Parameters</Modal.Title>
            </Modal.Header>
            <Modal.Body>

              <div className="d-flex justify-content-start flex-wrap">
                <div className="m-1">
                  <label className="mr-5" htmlFor="description">Quote Number:</label>
                  <input className="form-control mb-3"
                    type="text"
                    name="userid"
                    disabled
                    id="userid"
                    value={fastQuoteCabinet.fastquotingcabinetnumber}/>
                </div>  
                <div className="m-1">
                  <label className="mr-5" htmlFor="description">Version Number:</label>
                  <input className="form-control mb-3"
                    type="text"
                    name="userid"
                    disabled
                    id="userid"
                    value={editbr.versionnumber?editbr.versionnumber.padStart(5,"0"):null}
                  />
                </div>    
              </div>
              <h5>Assembly Costs</h5>                                   
              <div className="d-flex justify-content-start flex-wrap">                
                <div className="m-1">
                  <label className="mr-5" htmlFor="description">Base and Wall Assembly cost:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="assemblycostbasewallcost"
                    id="assemblycostbasewallcost"
                    onChange={onChangeassemblycostbasewallcost}
                    value={assemblycostbasewallcost}
                    />
                </div> 
                <div className="m-1">
                  <label className="mr-5" htmlFor="email">Tall Assembly Cost:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="assemblycosttallcost"
                    id="assemblycosttallcost"
                    onChange={onChangeassemblycosttallcost}
                    value={assemblycosttallcost}
                    />
                </div>
              </div>                        
              <h5>Hardware Costs</h5>                                   
              <div className="d-flex justify-content-start flex-wrap">
                <div className="m-1">
                  <label className="mr-5" htmlFor="email">Hardware Hinges Base-Wall Cost:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="hardwarehingesbasewallcost"
                    id="hardwarehingesbasewallcost"
                    value={hardwarehingesbasewallcost}
                    onChange={onChangehardwarehingesbasewallcost}
                    />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="email">Hardware Hinges Tall Cost:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="hardwarehingestallcost"
                    id="hardwarehingestallcost"
                    value={hardwarehingestallcost}
                    onChange={onChangehardwarehingestallcost}
                    />
                </div>
              </div>  

              <h5>Routing Cost</h5>                                   
              <div className="d-flex justify-content-start flex-wrap">                
                <div className="m-1">
                  <label className="mr-5" htmlFor="email">Routing Cost:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="routingcost"
                    id="routingcost"
                    value={routingcost}
                    onChange={onChangeroutingcost}
                    />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="email">Routing Cost Case Base:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="routingcostcasesqftbase"
                    id="routingcostcasesqftbase"
                    value={routingcostcasesqftbase}
                    onChange={onChangeroutingcostcasesqftbase}
                    />
                </div>   
                <div className="m-1">
                  <label className="mr-5" htmlFor="email">Routing Cost Case Wall:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="routingcostcasesqftwall"
                    id="routingcostcasesqftwall"
                    value={routingcostcasesqftwall}
                    onChange={onChangeroutingcostcasesqftwall}
                    />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="email">Routing Cost Case Tall:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="routingcostcasesqfttall"
                    id="routingcostcasesqfttall"
                    value={routingcostcasesqfttall}
                    onChange={onChangeroutingcostcasesqfttall}
                    />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="email">Routing Cost Back Base:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="routingcostbacksqftbase"
                    id="routingcostbacksqftbase"
                    value={routingcostbacksqftbase}
                    onChange={onChangeroutingcostbacksqftbase}
                    />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="routingcostbacksqftwall">Routing Cost Back Wall:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="routingcostbacksqftwall"
                    id="routingcostbacksqftwall"
                    value={routingcostbacksqftwall}
                    onChange={onChangeroutingcostbacksqftwall}
                    />
                </div>   
                <div className="m-1">
                  <label className="mr-5" htmlFor="routingcostbacksqfttall">Routing Cost Back Tall:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="routingcostbacksqfttall"
                    id="routingcostbacksqfttall"
                    value={routingcostbacksqfttall}
                    onChange={onChangeroutingcostbacksqfttall}
                    />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="routingcostdoorssqftbase">Routing Cost Doors Base:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="routingcostdoorssqftbase"
                    id="routingcostdoorssqftbase"
                    value={routingcostdoorssqftbase}
                    onChange={onChangeroutingcostdoorssqftbase}
                    />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="routingcostdoorssqftwall">Routing Cost Doors Wall:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="routingcostdoorssqftwall"
                    id="routingcostdoorssqftwall"
                    value={routingcostdoorssqftwall}
                    onChange={onChangeroutingcostdoorssqftwall}
                    />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="routingcostdoorssqfttall">Routing Cost Doors Tall:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="routingcostdoorssqfttall"
                    id="routingcostdoorssqfttall"
                    value={routingcostdoorssqfttall}
                    onChange={onChangeroutingcostdoorssqfttall}
                    />
                </div>   
                <div className="m-1">
                  <label className="mr-5" htmlFor="routingcostfinishendssqftbase">Routing Cost Finished Ends Base:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="routingcostfinishendssqftbase"
                    id="routingcostfinishendssqftbase"
                    value={routingcostfinishendssqftbase}
                    onChange={onChangeroutingcostfinishendssqftbase}
                    />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="routingcostfinishendssqftwall">Routing Cost Finished Ends Wall:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="routingcostfinishendssqftwall"
                    id="routingcostfinishendssqftwall"
                    value={routingcostfinishendssqftwall}
                    onChange={onChangeroutingcostfinishendssqftwall}
                    />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="routingcostfinishendssqfttall">Routing Cost Finished Ends Tall:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="routingcostfinishendssqfttall"
                    id="routingcostfinishendssqfttall"
                    value={routingcostfinishendssqfttall}
                    onChange={onChangeroutingcostfinishendssqfttall}
                    />
                </div>
              </div>  

              <h5>Markups</h5>                                   
              <div className="d-flex justify-content-start flex-wrap">
                <div className="m-1">
                  <label className="mr-5" htmlFor="materialcostcasemarkup">Material Cost Case Markup:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="materialcostcasemarkup"
                    id="materialcostcasemarkup"
                    value={materialcostcasemarkup}
                    onChange={onChangematerialcostcasemarkup}
                  />
                </div>    
                <div className="m-1">
                  <label className="mr-5" htmlFor="materialcostbackmarkup">Material Cost Back Markup:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="materialcostbackmarkup"
                    id="materialcostbackmarkup"
                    value={materialcostbackmarkup}
                    onChange={onChangematerialcostbackmarkup}
                  />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="materialcostdoorsmarkup">Material Cost Doors Markup:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="materialcostdoorsmarkup"
                    id="materialcostdoorsmarkup"
                    value={materialcostdoorsmarkup}
                    onChange={onChangematerialcostdoorsmarkup}
                  />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="materialcostfinishendsmarkup">Material Cost Finished Ends Markup:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="materialcostfinishendsmarkup"
                    id="materialcostfinishendsmarkup"
                    value={materialcostfinishendsmarkup}
                    onChange={onChangematerialcostfinishendsmarkup}
                  />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="ebcostcasebase">EB Cost Case Base:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="ebcostcasebase"
                    id="ebcostcasebase"
                    value={ebcostcasebase}
                    onChange={onChangeebcostcasebase}
                  />
                </div>   
                <div className="m-1">
                  <label className="mr-5" htmlFor="ebcostcasewall">EB Cost Case Wall:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="ebcostcasewall"
                    id="ebcostcasewall"
                    value={ebcostcasewall}
                    onChange={onChangeebcostcasewall}
                  />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="ebcostcasetall">EB Cost Case Tall:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="ebcostcasetall"
                    id="ebcostcasetall"
                    value={ebcostcasetall}
                    onChange={onChangeebcostcasetall}
                  />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="ebcostcasemarkup">EB Cost Case Markup:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="ebcostcasemarkup"
                    id="ebcostcasemarkup"
                    value={ebcostcasemarkup}
                    onChange={onChangeebcostcasemarkup}
                  />
                </div>                
                <div className="m-1">
                  <label className="mr-5" htmlFor="ebcostdoorsbase">EB Cost Doors Base:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="ebcostdoorsbase"
                    id="ebcostdoorsbase"
                    value={ebcostdoorsbase}
                    onChange={onChangeebcostdoorsbase}
                  />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="ebcostdoorswall">EB Cost Doors Wall:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="ebcostdoorswall"
                    id="ebcostdoorswall"
                    value={ebcostdoorswall}
                    onChange={onChangeebcostdoorswall}
                  />
                </div>   
                <div className="m-1">
                  <label className="mr-5" htmlFor="ebcostdoorstall">EB Cost Doors Tall:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="ebcostdoorstall"
                    id="ebcostdoorstall"
                    value={ebcostdoorstall}
                    onChange={onChangeebcostdoorstall}
                  />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="ebcostcasemarkup">EB Cost Doors Markup:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="ebcostcasemarkup"
                    id="ebcostcasemarkup"
                    value={ebcostcasemarkup}
                    onChange={onChangeebcostdoorsmarkup}
                  />
                </div>

                <div className="m-1">
                  <label className="mr-5" htmlFor="drawercostdrawer">Drawer Cost:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="drawercostdrawer"
                    id="drawercostdrawer"
                    value={drawercostdrawer}
                    onChange={onChangedrawercostdrawer}
                  />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="drawercosthardware">Drawers Hardware Cost:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="drawercosthardware"
                    id="drawercosthardware"
                    value={drawercosthardware}
                    onChange={onChangedrawercosthardware}
                  />
                </div>                
                <div className="m-1">
                  <label className="mr-5" htmlFor="drawercostmarkup">Drawers Cost Markup:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="drawercostmarkup"
                    id="drawercostmarkup"
                    value={drawercostmarkup}
                    onChange={onChangedrawercostmarkup}
                  />
                </div>
                <div className="m-1">
                  <label className="mr-5" htmlFor="faceframemarkup">Face Frame Markup:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="faceframemarkup"
                    id="faceframemarkup"
                    value={faceframemarkup}
                    onChange={onChangefaceframemarkup}
                  />
                </div>
              </div>

              <h5>Delivery</h5>                                   
              <div className="d-flex justify-content-start flex-wrap">                
                <div className="m-1">
                  <label className="mr-5" htmlFor="basicdeliverycost40cab">Basic Delivery Cost 40 Cab:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="basicdeliverycost40cab"
                    id="basicdeliverycost40cab"
                    value={basicdeliverycost40cab}
                    onChange={onChangebasicdeliverycost40cab}
                    />
                </div>                                                                                                                                          
              </div>

              <h5>Unknown Factor</h5>                                   
              <div className="d-flex justify-content-start flex-wrap">                
                <div className="m-1">
                  <label className="mr-5" htmlFor="unknownfactor">Basic Delivery Cost 40 Cab:</label>
                  <input className="form-control mb-3"
                    type="number"
                    name="unknownfactor"
                    id="unknownfactor"
                    value={unknownfactor}
                    onChange={onChangeunknownfactor}
                    />
                </div>                                                                                                                                          
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => {handleSaveVersion(editbr.fastquotingcabinetId, mode)}} variant="primary">
                  Save
              </Button>

              <Button variant="secondary" onClick={handleClose}>
                  Close
              </Button>
                  
            </Modal.Footer>
          </Modal>  

          <br></br>
        </Container>   
      </Container>         
    </div>
    </>
  )  
}


const ListOfJobs = (props) => {
  if (!props.jobs) {
    return 
  }
  const rows = props.jobs.map((row, index) => {
    return (  
      <option key={index} value={row.id}>        
        {row.jobtitle}
      </option>
    )
  })  
  return (      
    <>        
    <option disabled selected>
      {"Select"}
    </option>
    {rows}
    </>
  )
}

const ListOfFinishCabinet = (props) => {
  if (!props.finishcabinets) {
    return 
  }
  const rows = props.finishcabinets.map((row, index) => {
    return (  
      <option key={index} value={row.id} selected={props.defaultValue == row.id}>        
        {row.itemdescription}
      </option>
    )
  })  
  return (      
    <>        
    <option disabled selected={props.defaultValue == null}>
      {"Select"}
    </option>
    {rows}
    </>
  )
}

const ListOfFinishCabinetDoor = (props) => {
  if (!props.finishcabinetdoors) {
    return 
  }
  const rows = props.finishcabinetdoors.map((row, index) => {
    return (  
      <option key={index} value={row.id} selected={props.defaultValue == row.id}>        
        {row.itemdescription}
      </option>
    )
  })  
  return (      
    <>        
    <option disabled selected={props.defaultValue === null}>
      {"Select"}
    </option>
    {rows}
    </>
  )
}


export default NewCabinetFastQuote;
